import { useEffect, useLayoutEffect } from 'react';

/**
 * `useLayoutEffect` in the browser, `useEffect` on the server.
 *
 * The server has no layout to run before, and React prints a warning with a full component stack for
 * every layout effect it meets there, on every render. Neither kind of effect runs on the server, so the
 * swap changes nothing but the log; in the browser this is exactly `useLayoutEffect`.
 */
export const useIsomorphicLayoutEffect = typeof document !== 'undefined' ? useLayoutEffect : useEffect;
